import React from 'react'
import {Grid, Row, Col, FormControl, Button} from 'react-bootstrap'
import { store } from '../../../store'

const initialState = {
	name: '',
	email: '',
	username: '',
	status: '',
	error: ''
}
let user = store.getState().user.user
class GeneralSettings extends React.Component {
constructor(props) {
	super(props)
	this.state = initialState
}
componentDidMount() {
	if(user)
		this.setState({
		name: user.name,
		email: user.email,
		username: user.username,
	})
}
onStatus = (text) => {
  this.setState({status: text})
}
handleSubmit = () => {
	this.onStatus('processing')
	let {name, email, username, error} = this.state
	let userData = null
	if(name === '' && email === '') {
  		this.setState({error: 'empty'})
	}
	else if(name === '') {
  		this.setState({error: 'name'})
	}
	else if(email === '') {
  		this.setState({error: 'email'})
	}
	if(error === ' EMAIL_EXISTS ') {
  		this.setState({error: 'email'})
	}
  	if(error === '') {
  		if(name !== user.name) {
			userData = {
				name: name
			}
  		}
  		else if(email !== user.email) {
			userData = {
				email: email
			}
  		}
  		else if(email !== user.email && name !== user.name) {
			userData = {
				name: name,
				email: email
			}
  		}
		fetch('http://localhost:3002/settings', {
			method: 'post',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({
			user: userData,
			token: store.getState().user.token,
			username: username
		})
		})
  		.then(response => {
  			response.json()
  			.then(data => {
        	if (data.name && !data.email) {
        	this.props.onUser({
				name: data.name,
				bio: user.bio,
				email: user.email,
				id: user.id,
				joined: user.joined,
				username: user.username,
				propic: user.propic,
				verified: user.verified
                })
        	}
        	if (!data.name && data.email) {
        	this.props.onUser({
				name: user.name,
				bio: user.bio,
				email: data.email,
				id: user.id,
				joined: user.joined,
				username: user.username,
				propic: user.propic,
				verified: user.verified
                })
        	}
        	if (data.name && data.email) {
        	this.props.onUser({
				name: data.name,
				bio: user.bio,
				email: data.email,
				id: user.id,
				joined: user.joined,
				username: user.username,
				propic: user.propic,
				verified: user.verified
                })
        	}
			this.onStatus('success')
			})
		})
  	}
  	else {
  		this.setState({error: 'missmatch'})
  	}
}
onButton = () => {
   	if(this.state.status === '')
   	return this.handleSubmit()
   	else return null
}
addEmail = (e) => {
	this.setState({email: e.target.value})
	fetch('http://localhost:3002/validation', {
			method: 'post',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({
			email: e.target.value
		})
	})
  	.then(response => {
  	response.json()
  	.then(data => {
    if(data.email === 'EMAIL_EXISTS' && this.state.email !== user.email)
    {
    this.setState({
    	error: 'email_exist'
    })
    }
	else {
    this.setState({
    	error: ''
    })
  }
  })
  })
}
	render() {
	let {Rolling} = this.props
	let {name, username, email, status, error} = this.state
	if(this.state.status === 'success') {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    2000
			)
			}
	return (<div className="settings_inside">
		<h3>General Settings</h3>
		<div className="settings_inside_content">
		<Grid>
		<Row className="settings_sections">
		<Col lg={2} md={2} sm={6} xs={2}>
		<span>Username</span>
		</Col>
		<Col lg={8} md={8} sm={6} xs={10}><FormControl 
            spellcheck="false"
            className="settings_form settings_form_locked"
            autocomplete="off"
            type="locked" 
            name="username"
            value={username}
            placeholder="Username"
            size="6"
            readonly
          />
         </Col>
         </Row>
         <Row className="settings_sections">
         <Col lg={2} md={2} sm={6} xs={2}>
	      <span>Name</span>
	      </Col>
	      <Col lg={8} md={8} sm={6} xs={10}>
	      <FormControl 
	        spellcheck="false"
	        className={
            error === 'name' || error === 'empty'
            	?	'settings_form redd'
            	:	'settings_form'
            }
	        autocomplete="off"
	        type="text" 
	        name="username"
	        value={name}
            onChange={(e)=>this.setState({name: e.target.value})}
	        placeholder="Full Name"
	        size="6"
	      />
	      </Col>
	      </Row>
	      <Row className="settings_sections">
	      <Col lg={2} md={2} sm={6} xs={2}>
          <span>Email</span>
          </Col>
          <Col lg={8} md={8} sm={6} xs={10}>
          <FormControl 
            spellcheck="false"
            className={
            error === 'email_exist' || error === 'email' || error === 'empty'
            	?	'settings_form redd'
            	:	'settings_form'
            }
            autocomplete="off"
            type="text" 
            name="username"
            value={email}
            onChange={(e)=>this.addEmail(e)}
            placeholder="Full Name"
            size="6"
          />
          </Col>
	      </Row>
	      <Row className="settings_sections">
	      <Col lg={8} md={8} sm={6} xs={10}>
	       <Button className={status === 'success'
	      ?	'btn_save'
	      : 'top_btn'
			}
	       onClick={this.onButton.bind()}>
	 		{status === 'success'
	      ?	<span className="rolling"><svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span>
	      : null
	  		}
	  		{status === 'processing'
	      ?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
	      : null
	 		}
	  		{!status
	      ?<div className="rolling_save"><span>Save</span></div>
	      : null
	 		}
	      </Button>
	      </Col>
	      </Row>
          </Grid>
          </div>
		</div>)
}
}
export default GeneralSettings